/**
 * Client-side premium lock helper.
 * Never test item.is_locked alone — loading and premium status must be considered.
 */
export const isLocked = (item, isPremium, isLoading) =>
  Boolean(item?.is_locked) && !isLoading && !isPremium();
